
import React from 'react';
import styles from './SidebarItem.module.css';
import { Link } from 'react-router-dom';

const SidebarItem = ({ to, icon, children, collapsed=false, ...props }) => {
  const content = (
    <div className={styles.inner}>
      {icon && <span className={styles.icon}>{icon}</span>}
      {!collapsed && <span className={styles.label}>{children}</span>}
    </div>
  );
  if (to) {
    return (
      <li className={styles.menuItem} {...props}>
        <Link to={to} aria-label={typeof children === 'string' ? children : undefined} style={{ textDecoration: 'none', color: 'inherit', width: '100%', display: 'block' }}>
          {content}
        </Link>
      </li>
    );
  }
  return (
    <li className={styles.menuItem} {...props}>
      {content}
    </li>
  );
};

export default SidebarItem;
